<template>
    <div class="d-block">
        <div class="details-banner">
            <div class="d-block bg-dark line-h-0" v-if="bannerData.mediaType === 'VIDEO'">
                <video autoplay loop muted="true" :src="bannerData.urls[0]" :style="{width: '100%', height: '320px'}"/>
            </div>
            <img :src="bannerData.urls[Math.floor(Math.random() * 4)]" v-if="bannerData.mediaType === 'IMAGE'"/>
            <div class="content">
                <h1 v-if="bannerData.titleType === 'TXT'" style="font-size: 3em;">{{ bannerData.title }}</h1>
                <h6 v-if="bannerData.titleType === 'ICON'">
                    <img :src="bannerData.icon" style="max-height: 72px;"/>
                </h6>
                <br/>
                <h1>{{ bannerData.introduction }}</h1>
            </div>
        </div>
        <div class="details-container" v-if="detailsData">
            <div class="public-article-title">
                <h1>{{ detailsData.title }}</h1>
                <h6>
                    <span class="plr-sm">{{ language === 'zh-cn' ? '作者' : 'Author' }}：{{ paramsData.author }}</span>
                    <span class="plr-sm">{{ language === 'zh-cn' ? '发布时间' : 'Send Time' }}：{{ paramsData.updateTime }}</span>
                </h6>
            </div>
            <br/>
            <h2 class="d-block ptb-xxl align-center">{{ detailsData.introduction }}</h2>
            <div class="d-block ptb-xl" v-if="detailsData.image.enable === true">
                <photo-contrast v-bind:data="detailsData.image"/>
            </div>
            <div class="d-block ptb-xl" v-if="detailsData.video.enable === true">
                <div class="d-block pb-lg align-center">
                    <h1 class="size-24">{{ detailsData.video.title }}</h1>
                    <h2>{{ detailsData.video.introduction }}</h2>
                </div>
                <video-player ref="VideoPlayer" v-bind:data="detailsData.video.video" style="height: 768px;"/>
            </div>
            <div class="d-block" data-box="article-content" v-html="detailsData.content"></div>
            <div class="d-block align-center" v-if="detailsData.type === 'NEWS'">
                <a class="btn-load-more mlr-xs" @click="__getPrevNews(detailsData)">上一篇</a>
                <a class="btn-load-more mlr-xs" @click="__getNextNews(detailsData)">下一篇</a>
            </div>
            <div class="d-block align-center" v-if="detailsData.type === 'ACTIVITY'">
                <a class="btn-load-more mlr-xs" @click="__getPrevActivity(detailsData)">上一篇</a>
                <a class="btn-load-more mlr-xs" @click="__getNextActivity(detailsData)">下一篇</a>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import PhotoContrast from "../../components/PhotoContrast";
    import VideoPlayer from "../../components/VideoPlayer";

    export default {
        components: {
            PhotoContrast,
            VideoPlayer,
        },
        data () {
            return {
                language: 'zh-cn',
                bannerData: {},
                paramsData: {},
                detailsData: null,
            }
        },
        created() {
            console.log('当前语言----->' + this.$store.state.language);
            this.language = this.$store.state.language;
            this.__getParamsData();
            this.__getBanner();
        },
        mounted() {
        },
        methods: {
            onPublicTabs(data, i){
                console.log(data, i);
                this.tabsActive = i;
            },
            __getBanner(){
                this.$api.getHttp('banner?bannerType=NEWS_ACTIVITIES', {
                    language: this.language,
                }).then((res) => {
                    // console.log('<---------- res ---------->');
                    // console.log(res);
                    if (res.status === 200){
                        console.log('<---------- res ---------->');
                        this.bannerData = res.data.data;
                        // 截取随机数
                        // if (this.bannerData.urls > 0){
                        //     let randomNum = Math.floor(Math.random() * 4);
                        //     this.bannerData.bgImage = this.bannerData.urls[randomNum];
                        //     console.log(this.bannerData);
                        // } else {
                        //     this.bannerData.bgImage = this.bannerData.urls[0];
                        //     console.log(this.bannerData);
                        // }
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },
            __getParamsData(){
                if (this.$route.params.data) {
                    let _data = JSON.parse(this.$route.params.data);
                    console.log('paramsData----->', _data);
                    this.paramsData = _data;
                    if (this.paramsData.type === 'NEWS'){
                        this.__getNewsDetails(_data);
                    }
                    if (this.paramsData.type === 'ACTIVITY'){
                        this.__getActivityDetails(_data);
                    }
                }
            },

            __getNewsDetails(data){
                this.before();
                this.$api.getHttp('news/' + data.id, {
                    language: this.$store.state.language,
                }).then((res) => {
                    if (res.status === 200){
                        this.detailsData = res.data.data;
                        this.detailsData.type = 'NEWS';
                        this.$forceUpdate();
                        // console.log(this.detailsData);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },

            __getActivityDetails(data){
                this.before();
                this.$api.getHttp('activities/' + data.id, {
                    language: this.$store.state.language,
                }).then((res) => {
                    if (res.status === 200){
                        this.detailsData = res.data.data;
                        this.detailsData.type = 'ACTIVITY';
                        this.$forceUpdate();
                        // console.log(this.detailsData);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },

            __getPrevNews(data){
                this.before();
                this.$api.getHttp('news/prev/' + data.id, {
                    language: this.$store.state.language,
                }).then((res) => {
                    if (res.status === 200){
                        if (res.data.data){
                            this.detailsData = res.data.data;
                            this.detailsData.type = 'NEWS';
                            this.$forceUpdate();
                        } else {
                            this.$Modal.warning({
                                title: this.language === 'zh-cn' ? '提示' : 'Tips',
                                content: this.language === 'zh-cn' ? '当前已经是第一篇' : 'This is the first one',
                                okText: this.language === 'zh-cn' ? '确定' : 'OK'
                            });
                        }
                        // console.log(this.detailsData);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },

            __getNextNews(data){
                this.before();
                this.$api.getHttp('news/next/' + data.id, {
                    language: this.$store.state.language,
                }).then((res) => {
                    if (res.status === 200){
                        if (res.data.data){
                            this.detailsData = res.data.data;
                            this.detailsData.type = 'NEWS';
                            this.$forceUpdate();
                        } else {
                            this.$Modal.warning({
                                title: this.language === 'zh-cn' ? '提示' : 'Tips',
                                content: this.language === 'zh-cn' ? '当前已经是最后一篇' : 'This is the Last one',
                                okText: this.language === 'zh-cn' ? '确定' : 'OK'
                            });
                        }
                        // console.log(this.detailsData);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },
            __getPrevActivity(data){
                this.before();
                this.$api.getHttp('activities/prev/' + data.id, {
                    language: this.$store.state.language,
                }).then((res) => {
                    if (res.status === 200){
                        if (res.data.data){
                            this.detailsData = res.data.data;
                            this.detailsData.type = 'ACTIVITY';
                            this.$forceUpdate();
                        } else {
                            this.$Modal.warning({
                                title: this.language === 'zh-cn' ? '提示' : 'Tips',
                                content: this.language === 'zh-cn' ? '当前已经是第一篇' : 'This is the first one',
                                okText: this.language === 'zh-cn' ? '确定' : 'OK'
                            });
                        }
                        // console.log(this.detailsData);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },
            __getNextActivity(data){
                this.before();
                this.$api.getHttp('activities/next/' + data.id, {
                    language: this.$store.state.language,
                }).then((res) => {
                    if (res.status === 200){
                        if (res.data.data){
                            this.detailsData = res.data.data;
                            this.detailsData.type = 'ACTIVITY';
                            this.$forceUpdate();
                        } else {
                            this.$Modal.warning({
                                title: this.language === 'zh-cn' ? '提示' : 'Tips',
                                content: this.language === 'zh-cn' ? '当前已经是最后一篇' : 'This is the Last one',
                                okText: this.language === 'zh-cn' ? '确定' : 'OK'
                            });
                        }
                        // console.log(this.detailsData);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },

            before() {
                if (this.detailsData && this.detailsData.image) {
                    this.detailsData.image.enable = false
                }
                if (this.detailsData && this.detailsData.video) {
                    this.detailsData.video.enable = false
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/news/details.vue